import { Action } from '@ngrx/store';
import { RecommendationCategoryInterface } from 'app/recommendation/models/recommendation-category.model';

import { RecommendationInterface, RecommendationTemplateInterface, RecommendationTemplateRuleInterface } from '../../models';

import { RecommendationActionType } from './recommendation-action-type.enum';


export class DeleteEmployeeRecommendation implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteEmployeeRecommendation;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class DeleteEmployeeRecommendationCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteEmployeeRecommendationCompleted;

  constructor(public readonly payload: number) { }
}

export class DeleteEmployeeRecommendationFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteEmployeeRecommendationFailed;

  constructor(public readonly payload: string) { }
}

export class DeleteRecommendationTemplate implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteRecommendationTemplate;

  constructor(public readonly payload: RecommendationTemplateInterface) { }
}

export class DeleteRecommendationTemplateCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteRecommendationTemplateCompleted;

  constructor(public readonly payload: RecommendationTemplateInterface) { }
}

export class DeleteRecommendationTemplateFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteRecommendationTemplateFailed;

  constructor(public readonly payload: string) { }
}

export class DeleteRecommendationCategory implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteRecommendationCategory;

  constructor(public readonly payload: RecommendationCategoryInterface) { }
}

export class DeleteRecommendationCategoryCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteRecommendationCategoryCompleted;

  constructor(public readonly payload: RecommendationCategoryInterface) { }
}

export class DeleteRecommendationCategoryFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteRecommendationCategoryFailed;

  constructor(public readonly payload: string) { }
}

export class DeleteRecommendationTemplateRule implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteRecommendationTemplateRule;

  constructor(public readonly payload: {recommendation: RecommendationInterface, rule: RecommendationTemplateRuleInterface}) { }
}

export class DeleteRecommendationTemplateRuleCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteRecommendationTemplateRuleCompleted;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class DeleteRecommendationTemplateRuleFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.DeleteRecommendationTemplateRuleFailed;

  constructor(public readonly payload: string) { }
}
